/* eslint-disable max-lines-per-function */
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import {
  Body,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Separator,
} from '@e2n/ui/v2';
import {
  faCircle,
  faCircleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function KonfliktIndicator({
  konfliktStationen,
}: {
  konfliktStationen: ArbeitsbereichStation[];
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (konfliktStationen.length === 0) {
    return null;
  }

  const label = t(
    'domain.mitarbeiter.rotationsplan.rotationsplaene.konflikt.count',
    { count: konfliktStationen.length },
  );

  const trigger = (
    <Button variant="ghost" size="small" aria-label={label}>
      <FontAwesomeIcon
        className="size-3.5 text-error-red-200"
        icon={faCircleExclamation}
      />
      <Body className="ml-1" size="sm">
        {label}
      </Body>
    </Button>
  );

  const konfliktList = konfliktStationen.map((station, index) => (
    <Fragment key={station.id}>
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center min-w-0 gap-2">
          <FontAwesomeIcon
            className="size-2.5"
            icon={faCircle}
            color={station.arbeitsbereich.getBorderColor()}
          />
          <Body className="truncate">{station.arbeitsbereich.name}</Body>
        </div>
        <Body className="whitespace-nowrap">
          {dayjs(station.von).format('DD.MM') +
            ' - ' +
            dayjs(station.bis).format('DD.MM.YYYY')}
        </Body>
      </div>
      {index < konfliktStationen.length - 1 && <Separator />}
    </Fragment>
  ));

  return (
    <>
      <div className="hidden md:flex">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger
            asChild
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}>
            {trigger}
          </PopoverTrigger>
          <PopoverContent
            side="right"
            align="center"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            className="gap-2 px-4 py-3 md:min-w-75">
            {konfliktList}
          </PopoverContent>
        </Popover>
      </div>
      <Drawer>
        <DrawerTrigger className="flex md:hidden" asChild>
          {trigger}
        </DrawerTrigger>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>{label}</DrawerTitle>
          </DrawerHeader>
          <DrawerBody className="items-stretch gap-2">
            {konfliktList}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
